import { render, staticRenderFns } from "./EvidenceView.vue?vue&type=template&id=b81f8c26&scoped=true&"
import script from "./EvidenceView.vue?vue&type=script&lang=js&"
export * from "./EvidenceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81f8c26",
  null
  
)

export default component.exports